import { ReactComponent as OnboardingIcon } from "../../assets/svg/onboarding.svg";
import { ReactComponent as ResourcesIcon } from "../../assets/svg/resources.svg";
import { ReactComponent as InfrastructureIcon } from "../../assets/svg/infrastructure.svg";
import { ReactComponent as CultureIcon } from "../../assets/svg/culture.svg";
import { ReactComponent as CircularEconomyIcon } from "../../assets/svg/circular-economy.svg";
import { ReactComponent as InfluenceIcon } from "../../assets/svg/influence.svg";
import { TopicConfig } from "../../models/topicConfig.js";
import { ColorConfig } from "../../models/colorConfig.js";
import { TopicDataVizConfig } from "../../models/topicDataVizConfig.js";
// eslint-disable-next-line import/extensions
import { images } from "../../assets/images";
import { getString } from "../../services/stringsHelpers.js";

const RIGHT = "right";
const LEFT = "left";

/**
 * @param {{[key: string]: string | null}} strings
 */
export function getTopicsConfig(strings) {
  return [
    new TopicConfig({
      color: new ColorConfig({
        primary: "#D12287",
        rangeStart: "#FFD6E6",
        rangeEnd: "#FFF0F6",
        humanReadable: "magenta",
      }),
      icon: OnboardingIcon,
      mainTitle: getString("Onboarding", strings),
      subTitle: getString("How does the group chat work?", strings),
      dataViz: new TopicDataVizConfig({
        images: images.dataViz.titles.onboarding,
        orientation: RIGHT,
        // NOTE: we don't getString this because we getString it in TitleSlide.jsx
        customText: "How do visitors feel about their cellphones?",
      }),
    }),
    new TopicConfig({
      color: new ColorConfig({
        primary: "#0064AA",
        rangeStart: "#CEEBFF",
        rangeEnd: "#E3F3FF",
        humanReadable: "blue",
      }),
      icon: ResourcesIcon,
      mainTitle: getString("Resources", strings),
      subTitle: getString("What goes into our cellphones?", strings),
      dataViz: new TopicDataVizConfig({
        images: images.dataViz.titles.resources,
        orientation: LEFT,
      }),
    }),
    new TopicConfig({
      color: new ColorConfig({
        primary: "#00883B",
        rangeStart: "#C7F1DA",
        rangeEnd: "#E4F9ED",
        humanReadable: "green",
      }),
      icon: InfrastructureIcon,
      mainTitle: getString("Infrastructure", strings),
      subTitle: getString("What makes our cellphones work?", strings),
      dataViz: new TopicDataVizConfig({
        images: images.dataViz.titles.infrastructure,
        orientation: RIGHT,
      }),
    }),
    new TopicConfig({
      color: new ColorConfig({
        primary: "#C35514",
        rangeStart: "#FFDDC9",
        rangeEnd: "#FFEEE5",
        humanReadable: "orange",
      }),
      icon: CultureIcon,
      mainTitle: getString("Culture", strings),
      subTitle: getString("How do people use their cellphones?", strings),
      dataViz: new TopicDataVizConfig({
        images: images.dataViz.titles.culture,
        orientation: RIGHT,
      }),
    }),
    new TopicConfig({
      color: new ColorConfig({
        primary: "#FFD84C",
        rangeStart: "#FFEA9E",
        rangeEnd: "#FFF2C5",
        text: "#000",
        humanReadable: "yellow",
      }),
      icon: CircularEconomyIcon,
      mainTitle: getString("Circular Economy", strings),
      subTitle: getString("What happens to our old cellphones?", strings),
      dataViz: new TopicDataVizConfig({
        images: images.dataViz.titles.circularEconomy,
        orientation: LEFT,
      }),
    }),
    new TopicConfig({
      color: new ColorConfig({
        primary: "#74479B",
        rangeStart: "#F1E2FF",
        rangeEnd: "#F8F0FF",
        humanReadable: "purple",
      }),
      icon: InfluenceIcon,
      mainTitle: getString("Influence", strings),
      subTitle: getString("How do cellphones shape our lives?", strings),
      dataViz: new TopicDataVizConfig({
        images: images.dataViz.titles.influence,
        orientation: LEFT,
      }),
    }),
  ];
}
